// extracted by mini-css-extract-plugin
export var readingTime = "bZ_gk";